//@ts-nocheck
import Link from 'next/link';
import {
  ModalWrap,
  ContentModal,
  SimpleModal,
  Modalsubscribe
} from './Modal.styles';
import {
  CloseWhite,
  CloseBlackCircle,
  LogoBlog,
  LogoMartins
} from '@assets/svgs';

export enum LandscapeVariants {
  WHITE = 'white',
  BLACK = 'black'
}

type ModalProps = {
  children?: React.ReactNode;
  variant?: ModalVariants;
  onClose?: () => void;
  onCloseWriters?: () => void;
  contactModal?: boolean;
  showcontentModal?: boolean;
  title?: string;
  logo?: any;
  email?: string;
  whatAppmsg?: string;
  whatAppLink?: string;
  newsModal?: boolean;
  addStyle?: string;
  subscribeText?: string | boolean;
  aboutModal?: boolean;
  backModal?: string;
  productModal?: boolean;
  productName?: string;
  productContent?: any | unknown;
  productUrl?: string;
  productAction?: string;
};

const Modal = ({
  children,
  variant,
  onClose,
  onCloseWriters,
  contactModal,
  showcontentModal,
  title,
  logo,
  email,
  whatAppmsg,
  whatAppLink,
  newsModal,
  addStyle,
  writersModal,
  subscribeText,
  aboutModal,
  backModal,
  productModal,
  productName,
  productContent,
  productUrl,
  productAction
}: ModalProps) => {
  return (
    <>
      {contactModal && (
        <ModalWrap className={variant}>
          <CloseWhite animation="close" isActive={onClose} />
          <div>
            {/* {logo} */}
            {/* <LogoBlog color="#fff" /> */}
            <LogoMartins width={120} height={110} color="#fff" />
            <div>
              <h2 style={{ letterSpacing: '2px'}}>CONTACT US</h2>
              {/* <h2>about your success</h2> */}
            </div>
            <a className="telm" href="tel:+447502816932">
              +447502816932
            </a>
            {/* <div>
              <h2>CONTACT US</h2>
            </div> */}
            <Link href={`mailto:george.martins@jorgedd.com`}>george.martins@jorgedd.com</Link>
            {/* <Link
              href={`https://api.whatsapp.com/send?phone=+447502816932&text=${whatAppmsg}`}
            >
              {whatAppLink}
            </Link> */}

            <Link
              href={`https://calendly.com/georgedmartins/30min`}
              target="_blank"
            >
              Request a Private Conversation 
            </Link>
          </div>
        </ModalWrap>
      )}

      {showcontentModal && (
        <ContentModal>
          <div>
            <span></span>
            <CloseBlackCircle animation="circleClose" isActive={onClose} />
            <h3>{title}</h3>
            <section>{children}</section>
          </div>
        </ContentModal>
      )}

      {newsModal && (
        <SimpleModal style={{ background: backModal, cursor: 'auto' }}>
          <div style={{ border: addStyle }}>
            <Modalsubscribe>
              <h2>Subscribe to our Newsletter</h2>
              {subscribeText && <p>{subscribeText}</p>}
              <p>
                Our innovative way for you to subscribe and to speak to us is
                amazing. Just click on the <strong>“Subscribe Now”</strong>{' '}
                button and send us your name and email address.
                <br />
                <br /> If you would like to subscribe later, just press the{' '}
                <strong>“Cancel”</strong> button.
              </p>
              <div>
                {/* <Link
                  href={`https://api.whatsapp.com/send?phone=+447502816932&text=Welcome,%0a%0aPlease, send us your email to Subscribe to our Newsletter.%0a%0aYour Email:%0a%0aIf you wish to contact us, please, use this WhatsApp number also.%0a%0aThank you,%0aMartin's Writers`}
                >
                  Subscribe
                </Link> */}
                {/* <Link
                  href={`mailto:subscribe@jorgedd.com?subject=Subscribe to our Newsletter&body=Welcome,%0a%0a%0aPlease, send us your email to Subscribe to our Newsletter and receive the latest Martin's news in your email box.%0a%0a%0aYour Name:%0a%0aYour Email:%0a%0a%0aIf you would like to cancel your subscription, please send us an email to subscribe@jorgedd.com%0a%0a%0aThank you,%0a%0aMartin's Writers`}
                >
                  Subscribe
                </Link> */}
                <Link href={`https://tr.ee/HTsLna0sVN`}>Subscribe</Link>
                <span onClick={onClose}>Cancel</span>
              </div>
            </Modalsubscribe>
          </div>
        </SimpleModal>
      )}

      {writersModal && (
        <SimpleModal style={{ background: backModal, cursor: 'auto' }}>
          <div>
            <Modalsubscribe>
              <h2>Choose your favourite Writer</h2>
              <p>
                Choose your favourite writer and read amazing fashion stories
                about the most talented designers. Share your thoughts for each
                collection. Haute Couture and Ready-to-Wear. Be part of{' '}
                <b>"TheStory"</b> the fashion writers magazine and be inside the
                most fantastic fashoin world. Get ready to be a Writer, a
                Designer or a Model.
              </p>
              <h4
                style={{
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  fontSize: '14px',
                  letterSpacing: '1.4px'
                }}
              >
                Writers:
              </h4>
              <ul>
                <li>
                  <Link href="/">
                    George Martins -{' '}
                    <span> Fashion Writer & Fashion Designer</span>
                  </Link>
                </li>
                <li
                  style={{
                    opacity: '0.4',
                    cursor: 'default',
                    pointerEvents: 'none'
                  }}
                >
                  <Link href="/">
                    J.E. Robin - <span> Writer & Fashion Writer</span>
                  </Link>
                </li>
                <li
                  style={{
                    opacity: '0.4',
                    cursor: 'default',
                    pointerEvents: 'none'
                  }}
                >
                  <Link href="/">
                    Edward Lewis - <span> Fashion Writer</span>
                  </Link>
                </li>
              </ul>
              <div>
                <span onClick={onCloseWriters}>Cancel</span>
              </div>
            </Modalsubscribe>
          </div>
        </SimpleModal>
      )}

      {aboutModal && (
        <SimpleModal style={{ background: backModal, cursor: 'auto' }}>
          <div>
            <Modalsubscribe>
              <h1>The Martin’s House is a luxury editorial platform.</h1>
              <p style={{ color: 'rgba(0,0,0, 0.7)' }}>
                <b>
                  The Martin’s House is not a fashion brand.
                  <br />
                  It is not a media platform.
                  <br />
                  It is a house of identity.
                </b>
                <br />
                <br />
                We tell the stories women CEOs are living — but rarely allowed
                to speak.
                <br />
                <br />
                Through editorial storytelling, leadership narratives, and
                fashion-led identity work, The Martin’s House rebuilds the woman
                behind the brand.
                <br />
                <br />
                We do not ask women to abandon their beliefs, culture, or
                history in order to succeed.
                <br />
                We believe those elements are the source of their authority.
                <br />
                <br />
                This is where confidence is restored.
                <br />
                This is where impostor syndrome loses its voice.
                <br />
                This is where leadership becomes embodied.
                <br />
                <br />
                <br />
                <Link
                  href="https://calendly.com/georgedmartins/30min"
                  target="_blank"
                  style={{ textDecoration: 'underline' }}
                >
                  LET'S COLLABORATE
                </Link>{' '}
              </p>
              <div>
                <span onClick={onClose}>CLOSE</span>
              </div>
            </Modalsubscribe>
          </div>
        </SimpleModal>
      )}

      {productModal && (
        <SimpleModal style={{ background: backModal }}>
          <div style={{ border: addStyle }}>
            <Modalsubscribe>
              <h2>{productName}</h2>

              <p
                style={{ color: 'rgba(0,0,0, 0.7)' }}
                // dangerouslySetInnerHTML={{ __html: productContent }}
              >
                {productContent}
              </p>
              <div>
                <Link href={productUrl}>
                  {/* Go to this service */}
                  {productAction}
                </Link>
                <span onClick={onClose}>Close</span>
              </div>
            </Modalsubscribe>
          </div>
        </SimpleModal>
      )}
    </>
  );
};

export default Modal;
